import {
    ADMIN_SHORT_VIDEOS_GET,
  } from "../../types";
  
  const initialState = {
    shortVideos: [],
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case ADMIN_SHORT_VIDEOS_GET:
        return {
          ...state,
          shortVideos: action.payload,
        };
          default:
        return state;
    }
  }
  